module.exports = __webpack_public_path__ + "media/components/footer/static/icon__x-21052fa4c005e89851a7474a716573e6.svg";